"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _layout = require("../../layout");
var _paginationTheme = require("../paginationTheme");
function shouldForwardProp(propName) {
  switch (propName) {
    case "themeMode":
      return false;
  }
  return true;
}
const Container = (0, _styled.default)(_layout.Spacer, {
  shouldForwardProp
})(_ref => {
  let {
    themeMode,
    variant
  } = _ref;
  return `
    background: ${_paginationTheme.paginationTheme.container.background(themeMode)};
    height: ${_paginationTheme.paginationTheme.container.height(themeMode)};
    display: flex;
    align-items: center;
    padding: ${_paginationTheme.paginationTheme.container.padding(themeMode)};
    border-radius: ${_paginationTheme.paginationTheme.container.borderRadius(themeMode)};
    width: fit-content;
    box-shadow: ${variant === "floating" ? `${_paginationTheme.paginationTheme.container.boxShadow(themeMode)}` : "none"};
    box-sizing: border-box;
`;
});
exports.Container = Container;
//# sourceMappingURL=Container.js.map